import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { start as singleSpaStart } from 'single-spa';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

singleSpaStart();

bootstrapAngular();

/**
 * Habilita el modo del ambiente de producción de la aplicación
 *
 * *Enables production environment*
 */
function bootstrapAngular() {
  if (environment.production) {
    enableProdMode();
  }

  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}
